
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleNav = (target) => {
        setMenuOpen(false);
        if (target === '/about') {
            navigate('/about');
        } else if (target === '/services') {
            navigate('/services');
        } else {
            if (location.pathname !== '/') navigate('/');
            setTimeout(() => {
                const el = document.getElementById(target.replace('#', ''));
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-content">
                <div className="navbar-logo-title">
                    <img src={process.env.PUBLIC_URL + '/bar.png'} alt="Logo" className="navbar-logo" />
                    {/* <div className="navbar-title">Boun Health & Performance</div> */}
                </div>


                <div className={`navbar-buttons ${menuOpen ? 'open' : ''}`}>
                    <button className="nav-btn" onClick={() => handleNav('#hero')}>Home</button>
                    <button className="nav-btn" onClick={() => handleNav('/services')}>Services</button>
                    {/* <button className="nav-btn" onClick={() => handleNav('#contact')}>Contact</button> */}
                    <button className="nav-btn" onClick={() => handleNav('/about')}>About Me</button>
                </div>

                <button className="navbar-menu-icon" onClick={() => setMenuOpen(m => !m)} aria-label="Menu">
                    <span className="navbar-menu-bar"></span>
                    <span className="navbar-menu-bar"></span>
                    <span className="navbar-menu-bar"></span>
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
